import React, { Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { withRouter } from "react-router-dom";
import Login from "../../containers/Apps/Login";
import ResizeDetector from "react-resize-detector";
//import IdleTimer from "react-idle-timer";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LaddaButton from "react-ladda";
import * as actions from "../../reducers/auth/authActions";
import AppMain from "../../Layout/AppMain";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closedSmallerSidebar: false,
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
    this.logoutHandler = this.logoutHandler.bind(this);
  }

  componentDidMount() {
    this.props.onExistAccount();
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  logoutHandler(event) {
    this.toggle();
    this.props.onLogOutSoft();
  }

  render() {
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
      isLogin,
    } = this.props;
    return (
      <ResizeDetector
        handleWidth
        render={({ width }) => (
          <Fragment>
            <Modal
              size="md"
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.props.className}
            >
              <ModalHeader toggle={this.toggle}>{"Info"}</ModalHeader>
              <ModalBody>
                <p>
                  La sesión se encuentra a punto de expirar, ¿desea continuar
                  conectado?
                </p>
              </ModalBody>

              <ModalFooter>
                <Button
                  color="link"
                  onClick={this.logoutHandler}
                  className="mb-2 mr-2 btn btn-secondary"
                >
                  Desconectar sistema
                </Button>
                <LaddaButton
                  className="mb-2 mr-2 btn btn-primary"
                  loading={this.state.loader}
                  onClick={this.toggle}
                >
                  Continuar conectado
                </LaddaButton>{" "}
              </ModalFooter>
            </Modal>

            <div
              className={cx(
                "app-container app-theme-" + colorScheme,
                { "fixed-header": enableFixedHeader },
                { "fixed-sidebar": enableFixedSidebar || width < 1250 },
                { "fixed-footer": enableFixedFooter },
                { "closed-sidebar": enableClosedSidebar || width < 1250 },
                {
                  "closed-sidebar-mobile": closedSmallerSidebar || width < 1250,
                },
                { "sidebar-mobile-open": enableMobileMenu },
                { "body-tabs-shadow-btn": enablePageTabsAlt }
              )}
            >
              {isLogin ? (
                <Fragment>
                  <AppMain />
                </Fragment>
              ) : (
                <Fragment>
                  <Login />
                </Fragment>
              )}
            </div>
          </Fragment>
        )}
      />
    );
  }
}

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
  isLogin: state.auth.isLogin,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onLogOutSoft: () => dispatch(actions.signOutSoft()),
    onExistAccount: () => dispatch(actions.getAccount()),
  };
};

export default withRouter(connect(mapStateToProp, mapDispatchToProps)(Main));
